import React, { useState, useEffect } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { SelectPropTypes, SelectDefaultValues } from './select.prop-types';
import { Container, Label, StyledSelect, Hint, Optionals, Opts, ArrowIcon } from './Select.styled';
import Opt from './components/Option';
export const Select = (props) => {
    const [selected, setSelectedState] = useState(props.val || '');
    const onChange = (val) => {
        setSelectedState(val);
        props.onChanged && props.onChanged(val);
    };
    // Handle value prop change
    useEffect(() => {
        setSelectedState(props.val || '');
    }, [props.val]);
    const options = React.Children.map(props.children, child => {
        //@ts-ignore
        return React.cloneElement(child, {
        //@ts-ignore
        });
    });
    return (React.createElement(Container, { width: props.width ? props.width : undefined },
        React.createElement(ArrowIcon, { icon: faChevronDown }),
        React.createElement(StyledSelect, { isInvalid: !!props.isInvalid, onChange: val => onChange(val.target.value), value: selected || 'defaultValue', disabled: props.disabled || undefined, id: props.id || undefined },
            React.createElement("option", { disabled: true, value: 'defaultValue' }, props.placeholder),
            options),
        !props.noLabel &&
            React.createElement(Label, { hidden: !!selected }, props.label),
        (props.hint || props.optional) &&
            React.createElement(Optionals, null,
                React.createElement(Hint, null, props.hint),
                React.createElement(Opts, null, props.optional))));
};
Select.defaultProps = SelectDefaultValues;
Select.propTypes = SelectPropTypes;
export const Option = Opt;
//# sourceMappingURL=Select.js.map